<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template><k-dialog v-model="dialog_open" max-width="1000" persistent scrollable><k-card>
	<k-card-title style="border-bottom:1px solid #999">
		<k-icon color="primary" class="mr-3">fas fa-file-contract</k-icon>
		<b>{{site_config.app_name}} — Terms of Service (ToS)</b>
		<k-spacer/>
		<k-btn color="primary" @click="$emit('dialog_cancel')"><k-icon small class="mr-2">fas fa-xmark</k-icon>Close</k-btn>
	</k-card-title>
	<k-card-text class="mt-3 k-tos-body" style="" v-html="html">
	</k-card-text>
</k-card></k-dialog></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// req: { type: String, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		dialog_open: true,
		html: 'Loading license text…'
	}},
	computed: {
		...mapState(['site_config']),
		...mapGetters([]),
	},
	watch: {
	},
	created() {
		this.load_html()
	},
	mounted() {
	},
	methods: {
		async load_html() {
			// let url = 'https://rosetta.commongoodlt.com/src/licenses/rosetta-license.html'
			let url = '/src/licenses/rosetta-license.html'
			url = `${url}?v=${Date.now()}`
			try {
				let text_data
				let response = await fetch(url)
				if (response.ok) {
					text_data = await response.text()
					// console.warn('retrieved html', text_data)
				} else {
					console.warn('couldnt get html', response)
				}

				let parser = new DOMParser()
				let doc = parser.parseFromString(text_data, 'text/html')

				// strip h2
				doc.querySelector('h2')?.remove()

				this.html = doc.body.innerHTML

				// this.tos_html = $(html).find('body').html()

			} catch (error) {
				console.warn('couldnt get html 2', error)
			}
		}
	}
}
</script>

<style lang="scss">
.k-tos-body {
	font-size:16px;
	line-height:21px;

	blockquote {
		margin-left:12px;
		padding-left:8px;
		border-left:2px solid #999;
		margin-top:12px;
	}

	h3 {
		margin-top:20px;
		margin-bottom:4px;
	}

	li, p {
		margin-bottom:12px;
		margin-top:12px;
	}
}
</style>
